// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__34QpD","info":"Note_info__3biPK","note":"Note_note__3k0u5","actions":"Note_actions__dQVUQ"};